import { Routes, Route, Navigate, useParams } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import AdminLayout from "../admin/layout/AdminLayout";
import ProtectedRoute from "../components/ProtectedRoute";
import BusinessCompletionRoute from "../components/BusinessCompletionRoute";
import HomePage from "../enduser/pages/home/HomePage";
import LoginPage from "../enduser/pages/login/LoginPage";
import ForgotPasswordPage from "../enduser/pages/login/ForgotPasswordPage";
import ResetPasswordPage from "../enduser/pages/login/ResetPasswordPage";
import RegisterPage from "../enduser/pages/register/RegisterPage";
import EnquiryPage from "../enduser/pages/enquiry/EnquiryPage";
import BlogPage from "../enduser/pages/blog/BlogPage";
import RealWeddingsPage from "../enduser/pages/real-weddings/RealWeddingsPage";
import RealWeddingDetailPage from "../enduser/pages/real-weddings/RealWeddingDetailPage";
import PhotosPage from "../enduser/pages/photos/PhotosPage";
import TestimonialsPage from "../enduser/pages/testimonials/TestimonialsPage";
import WhyWeddingzVenuePage from "../enduser/pages/why-weddingzvenue/WhyWeddingzVenuePage";
import VenuesPage from "../enduser/pages/venues/VenuesPage";
import VenueDetailPage from "../enduser/pages/venues/VenueDetailPage";
import VendorsPage from "../enduser/pages/vendors/VendorsPage";
import ProfilePage from "../enduser/pages/profile/ProfilePage";
import BusinessCompletionProfile from "../enduser/pages/profile/BusinessCompletionProfile";
import PrivacyPolicyPage from "../enduser/pages/static/PrivacyPolicyPage";
import TermsConditionsPage from "../enduser/pages/static/TermsConditionsPage";
import CookiePolicyPage from "../enduser/pages/static/CookiePolicyPage";
import ContactUsPage from "../enduser/pages/static/ContactUsPage";
import FAQPage from "../enduser/pages/static/FAQPage";
import HelpCenterPage from "../enduser/pages/static/HelpCenterPage";
import ListYourBusinessPage from "../enduser/pages/static/ListYourBusinessPage";
import AdvertisePage from "../enduser/pages/static/AdvertisePage";
import PartnersPage from "../enduser/pages/static/PartnersPage";
import AdminLoginPage from "../admin/pages/LoginPage";
import AdminForgotPasswordPage from "../admin/pages/ForgotPasswordPage";
import AdminDashboard from "../admin/pages/Dashboard";
import AdminBusinessUsersPage from "../admin/pages/BusinessUsersPage";
import AdminEnquiriesUsersPage from "../admin/pages/EnquiriesUserPage";
import ManageUsersPage from "../admin/pages/ManageUsersPage";
import CreateUserPage from "../admin/pages/CreateUserPage";
import AdminCreateBusinessUserPage from "../admin/pages/CreateBusinessUserPage";
import AdminVenuesPage from "../admin/pages/VenuesPage";
import AdminVendorsPage from "../admin/pages/VendorsPage";
import AddRealWeddingPage from "../admin/pages/AddRealWeddingPage";
import AddBlogPage from "../admin/pages/AddBlogPage";
import RealWeddingsListPage from "../admin/pages/RealWeddingsListPage";
import BlogsListPage from "../admin/pages/BlogsListPage";
import ScrollToTop from "../components/ScrollToTop";
import PageMeta from "../components/PageMeta";
import NotFoundPage from "../enduser/pages/static/NotFoundPage";

function LegacyBlogDetailRedirect() {
  const { id } = useParams();
  return <Navigate to={`/blog/${id}`} replace />;
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <PageMeta />
      <Routes>
        <Route
          path="/"
          element={
            <MainLayout>
              <HomePage />
            </MainLayout>
          }
        />
        <Route
          path="/city/:citySlug"
          element={
            <MainLayout>
              <HomePage />
            </MainLayout>
          }
        />
        <Route
          path="/login"
          element={
            <MainLayout showHeader={false} showFooter={false}>
              <LoginPage />
            </MainLayout>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <MainLayout showHeader={false} showFooter={false}>
              <ForgotPasswordPage />
            </MainLayout>
          }
        />
        <Route
          path="/reset-password"
          element={
            <MainLayout showHeader={false} showFooter={false}>
              <ResetPasswordPage />
            </MainLayout>
          }
        />
        <Route
          path="/register"
          element={
            <MainLayout showHeader={false} showFooter={false}>
              <RegisterPage />
            </MainLayout>
          }
        />
        <Route
          path="/enquiry"
          element={
            <MainLayout showHeader={false} showFooter={false}>
              <EnquiryPage />
            </MainLayout>
          }
        />
        <Route
          path="/blog"
          element={
            <MainLayout>
              <BlogPage />
            </MainLayout>
          }
        />
        <Route path="/blogs" element={<Navigate to="/blog" replace />} />
        <Route
          path="/blog/:id"
          element={
            <MainLayout>
              <RealWeddingDetailPage />
            </MainLayout>
          }
        />
        <Route path="/blogs/:id" element={<LegacyBlogDetailRedirect />} />
        <Route
          path="/real-weddings"
          element={
            <MainLayout>
              <RealWeddingsPage />
            </MainLayout>
          }
        />
        <Route
          path="/real-weddings/:id"
          element={
            <MainLayout>
              <RealWeddingDetailPage />
            </MainLayout>
          }
        />
        <Route
          path="/photos"
          element={
            <MainLayout>
              <PhotosPage />
            </MainLayout>
          }
        />
        <Route
          path="/testimonials"
          element={
            <MainLayout>
              <TestimonialsPage />
            </MainLayout>
          }
        />
        <Route
          path="/why-weddingzvenue"
          element={
            <MainLayout>
              <WhyWeddingzVenuePage />
            </MainLayout>
          }
        />

        <Route
          path="/privacy-policy"
          element={
            <MainLayout>
              <PrivacyPolicyPage />
            </MainLayout>
          }
        />
        <Route
          path="/terms"
          element={
            <MainLayout>
              <TermsConditionsPage />
            </MainLayout>
          }
        />
        <Route
          path="/cookies"
          element={
            <MainLayout>
              <CookiePolicyPage />
            </MainLayout>
          }
        />
        <Route
          path="/contact"
          element={
            <MainLayout>
              <ContactUsPage />
            </MainLayout>
          }
        />
        <Route
          path="/faq"
          element={
            <MainLayout>
              <FAQPage />
            </MainLayout>
          }
        />
        <Route
          path="/help"
          element={
            <MainLayout>
              <HelpCenterPage />
            </MainLayout>
          }
        />
        <Route
          path="/list-your-business"
          element={
            <MainLayout>
              <ListYourBusinessPage />
            </MainLayout>
          }
        />
        <Route
          path="/advertise"
          element={
            <MainLayout>
              <AdvertisePage />
            </MainLayout>
          }
        />
        <Route
          path="/partners"
          element={
            <MainLayout>
              <PartnersPage />
            </MainLayout>
          }
        />

        <Route
          path="/venues"
          element={<Navigate to="/venues/all" replace />}
        />
        <Route
          path="/venues/:type/*"
          element={
            <MainLayout>
              <VenuesPage />
            </MainLayout>
          }
        />
        <Route
          path="/venue/:id"
          element={
            <MainLayout>
              <VenueDetailPage />
            </MainLayout>
          }
        />
        <Route
          path="/vendors/*"
          element={
            <MainLayout>
              <VendorsPage />
            </MainLayout>
          }
        />
        <Route
          path="/profile"
          element={
            <MainLayout>
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            </MainLayout>
          }
        />
        <Route
          path="/profile/business"
          element={
            <MainLayout showHeader={false} showFooter={false}>
              <BusinessCompletionRoute>
                <BusinessCompletionProfile />
              </BusinessCompletionRoute>
            </MainLayout>
          }
        />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/forgot-password" element={<AdminForgotPasswordPage />} />
        <Route
          path="/admin/dashboard"
          element={
            <AdminLayout>
              <AdminDashboard />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/business-users"
          element={
            <AdminLayout>
              <AdminBusinessUsersPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/enquiries-users"
          element={
            <AdminLayout>
              <AdminEnquiriesUsersPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/venues"
          element={
            <AdminLayout>
              <AdminVenuesPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/vendors"
          element={
            <AdminLayout>
              <AdminVendorsPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/users"
          element={
            <AdminLayout>
              <ManageUsersPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/create-user"
          element={
            <AdminLayout>
              <CreateUserPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/create-business-user"
          element={
            <AdminLayout>
              <AdminCreateBusinessUserPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/add-real-wedding/:id"
          element={
            <AdminLayout>
              <AddRealWeddingPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/add-real-wedding"
          element={
            <AdminLayout>
              <AddRealWeddingPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/add-blog/:id"
          element={
            <AdminLayout>
              <AddBlogPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/add-blog"
          element={
            <AdminLayout>
              <AddBlogPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/real-weddings"
          element={
            <AdminLayout>
              <RealWeddingsListPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/blogs"
          element={
            <AdminLayout>
              <BlogsListPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/bookings"
          element={
            <AdminLayout>
              <div className="admin-page-header">
                <h1 className="admin-page-title">Bookings</h1>
                <p className="admin-page-subtitle">
                  Booking management coming soon
                </p>
              </div>
            </AdminLayout>
          }
        />
        <Route
          path="/admin/content"
          element={
            <AdminLayout>
              <div className="admin-page-header">
                <h1 className="admin-page-title">Content Management</h1>
                <p className="admin-page-subtitle">
                  Content management coming soon
                </p>
              </div>
            </AdminLayout>
          }
        />
        <Route
          path="*"
          element={
            <MainLayout>
              <NotFoundPage />
            </MainLayout>
          }
        />
      </Routes>
    </>
  );
}

export default AppRoutes;
